module.exports = __webpack_public_path__ + "media/images/sp/stores/fuji/fuji_concept_03-afb067274a40e4b8472bbff9e4767923.jpg";